/* Quotation tool: item definitions (names, notes, sizes, which package includes what).
   PRICES ARE NOT HERE. Every price comes from the CRM database (quote_tool_items),
   matched by the key  "<section id>.<item id>"  e.g. "entrance.door".
   An item that has no price in the CRM is not shown in the tool. */

export const PKG_KEYS = ["basic", "premium", "luxury"];
const ALL = PKG_KEYS, PREM = ["premium", "luxury"], NONE = [];

export const PROPERTY_TYPES = [
  { id:'2bhk',      label:'2', unit:'BHK',      beds:2 },
  { id:'3bhk',      label:'3', unit:'BHK',      beds:3 },
  { id:'4bhk',      label:'4', unit:'BHK',      beds:4 },
  { id:'bungalow',  label:'Bungalow',  unit:'', beds:5 },
  { id:'penthouse', label:'Penthouse', unit:'', beds:4 },
  { id:'other',     label:'Other',     unit:'', beds:2 }
];

/* I(id, name, inc, note, size): inc = packages in which it is included by default.
   A = included in every package, O = optional add-on in every package.
   note = small text shown under the item (sizes / quantities). */
const I = (id, name, inc, note, size) => {
  // a note that starts with a measurement (e.g. 6'0" x 6'6") is treated as the item's size
  if (!size && note && /^\d+\u2019/.test(note)) { size = note; note = ""; }
  return { id, name, inc, note: note || "", size: size || "" };
};
const A = (id, name, note, size) => I(id, name, ALL, note, size);
const O = (id, name, note, size) => I(id, name, NONE, note, size);

const SIZE_WARD = '6’0" x 9’0", openable doors';

export function buildSections(beds, big){
  const rooms = beds + 2;               // bedrooms + living + kitchen (used for "per room" electrical items)
  const s = [];

  s.push({ id:'entrance', name:'Entrance & Lobby', items:[
    A('door','Safety door', '', '7\u20190" x 3\u20196"'),
    A('shoe','Shoe rack', '', '6\u20190" x 4\u20190"'),
    A('foyer','Foyer panelling', '', '12\u20190" x 10\u20190"'),
    A('console','Mirror / console'),
    O('lceil','Lobby false ceiling with profile lights'),
    O('bench','Foyer seating bench with storage'),
    O('smartlock','Digital smart lock'),
    O('nameplate','Designer name plate with backlight'),
    O('jaali','Decorative jaali / partition screen'),
    O('umbrella','Umbrella & key holder unit'),
    O('ewall','Entrance feature wall (stone / 3D panel)'),
    O('ecurtain','Door curtain / privacy partition'),
    O('inlay','Marble / stone inlay at entrance'),
    O('ewarm','Foyer wall lights & accent lighting')
  ]});

  s.push({ id:'living', name:'Living Room', items:[
    A('tvdrawers','TV unit drawers', '', '6\u20190" x 3\u20190"'),
    A('tvback','TV unit back side panelling', '', '10\u20190" x 8\u20190"'),
    A('charcoal','Decorative charcoal panels'),
    O('curtain','Curtains & blinds'),
    O('sofaset','3+2 sofa set'),
    O('centre','Centre table'),
    O('feature','Feature wall (texture / wallpaper)'),
    O('ceiling','Designer false ceiling with cove lights'),
    O('sofa','Sofa back console'),
    O('show','Showcase / display unit'),
    O('bar','Bar unit / mini bar'),
    O('wallbooks','Wall-to-wall bookshelf / library wall'),
    O('seating','Window seating with storage (bay window)'),
    O('partition','Wooden / glass partition'),
    O('fluted','Fluted wall panels'),
    O('stone','Stone / marble TV back wall cladding'),
    O('chand','Designer chandelier / statement light'),
    O('sheer','Sheer + blackout curtain (double layer)'),
    O('ledstrip','LED strip & spot lighting in panels'),
    O('rug','Designer rug & decor accessories'),
    O('alcove','Wall niche / decorative alcove'),
    O('speaker','Home theatre wiring & concealed speakers')
  ]});

  s.push({ id:'pooja', name:'Pooja Unit', items:[
    A('mandir','Teak wooden mandir cabinet', '', '4\u20190" x 3\u20190"'),
    A('backpanel','PU or acrylic back panel'),
    A('drawers','Drawers'),
    A('jali','Jali CNC cutting'),
    O('door','Pooja room carved doors'),
    O('ceil','Pooja false ceiling with dome'),
    O('marble','Marble flooring / platform'),
    O('bell','Hanging bells & decorative lighting')
  ]});

  s.push({ id:'dining', name:'Dining Area', items:[
    A('table','Dining table & 4 chairs'),
    A('crock','Crockery unit', '', '5\u20190" x 2\u20190"'),
    A('curwall','Curtains & wallpaper'),
    A('basin','Wash basin counter', '', '3\u20190" x 1\u20196"'),
    O('chairs2','2 extra chairs'),
    O('curtain','Curtains'),
    O('wallpaper','Wallpaper'),
    O('dwall','Dining feature wall / paneling'),
    O('dceil','Dining false ceiling'),
    O('dmirror','Dining wall mirror / decor mirror'),
    O('sideboard','Sideboard / buffet unit'),
    O('dbar','Bar cabinet with glass shutters'),
    O('pendant','Designer pendant lights')
  ]});

  s.push({ id:'kitchen', name:'Kitchen', items:[
    A('carcase','Modular base cabinets (carcase)'),
    A('tandem','Tandem drawers by Hettich', '5 nos.'),
    A('trolley','Trolley pull-out'),
    A('overhead','Overhead & loft storage', '8’0" x 3’0"'),
    A('handles','G-profile handles'),
    A('granite','Granite countertop'),
    A('onion','Onion basket', '1 no.'),
    A('pantry','Pantry unit without fitting'),
    I('acrylic','Acrylic shutters', PREM, 'Included in Premium & Luxury'),
    O('sinkhob','Sink, hob & chimney'),
    O('pantryfit','Pantry pull-out fitting', 'up to ₹30,000'),
    O('quartz','Quartz countertop'),
    O('onion2','Extra onion basket', '1 no.'),
    O('splash','Backsplash tiles'),
    O('kceil','Kitchen false ceiling'),
    O('carousel','Magic corner / carousel unit'),
    O('cutlery','Cutlery organisers'),
    O('bottle','Bottle pull-out & spice racks'),
    O('appl','Built-in appliance housing (oven / microwave)'),
    O('island','Kitchen island / breakfast counter'),
    O('dishrack','Plate & dish drying rack'),
    O('garbage','Under-sink waste bin pull-out'),
    O('ulight','Under-cabinet LED lighting'),
    O('kwall','Dado / wall cladding behind hob'),
    O('ro','Concealed RO / water purifier unit'),
    O('utility','Utility / service balcony cabinets')
  ]});

  s.push({ id:'bed1', name:'Master Bedroom', items:[
    A('bed','King size bed', '6’0" x 6’6"'),
    A('bedback','Bed-back cushions', '6’0" x 3’0"'),
    A('side','Bedside tables', '2 nos.'),
    A('wardrobe','Wardrobes & lofts', SIZE_WARD),
    A('dressing','Dressing without mirror'),
    A('mirror','Mirror', 'up to ₹5,000'),
    A('study','Study table'),
    A('shelf','Study overhead open shelf', '6’0" x 2’0"'),
    A('tvback','TV back side panelling', '', '6\u20190" x 4\u20190"'),
    A('sinkst','Storage below sink'),
    O('curtain','Curtains & blinds'),
    O('alumopen','Aluminium openable glass door'),
    O('alumslide','Aluminium sliding glass door'),
    O('chair','Study chair', 'up to ₹10,000'),
    O('walkin','Walk-in closet wardrobe'),
    O('ceiling','False ceiling with lights'),
    O('tv','TV unit'),
    O('wallpaper','Designer wallpaper / texture wall'),
    O('reading','Reading nook with window seat'),
    O('bench','Bed-end storage bench'),
    O('cove','Cove & profile lighting'),
    O('blackout','Blackout curtains with motorised track'),
    O('fullmirror','Full-length decorative mirror'),
    O('bathvan','Attached bath vanity & mirror unit')
  ]});

  for(let b=2;b<=beds;b++){
    const single = (b===2);
    s.push({ id:'bed'+b, name: single ? 'Bedroom 2 (Single bed)' : 'Bedroom '+b+' (Queen bed)', items:[
      single ? A('bed','Single bed', '3’0" x 6’6"') : A('bed','Queen size bed', '5’0" x 6’6"'),
      A('bedback','Bed-back cushions', '3’0" x 2’6"'),
      A('side','Bedside tables', '2 nos.'),
      A('wardrobe','Wardrobes & lofts', SIZE_WARD),
      A('dressing','Dressing without mirror'),
      A('mirror','Mirror', 'up to ₹5,000'),
      ...(single ? [
        A('study','Study table'),
        A('shelf','Study overhead storage', '6’0" x 2’0"')
      ] : []),
      O('sinkst','Storage below sink'),
      O('curtain','Curtains & blinds'),
      O('alumopen','Aluminium openable glass door'),
      O('alumslide','Aluminium sliding glass door'),
      O('chair','Study chair', 'up to ₹10,000'),
      ...(single ? [] : [ O('study','Study table with drawer', 'up to ₹25,000') ]),
      O('bed2','Additional single bed', '3’0" x 6’6"'),
      O('bedback2','Additional bed-back cushions', '3’0" x 2’6"'),
      O('tv','TV unit'),
      O('tvback','TV back side panelling'),
      O('ceiling','False ceiling with lights'),
      O('wallpaper','Designer wallpaper / texture wall'),
      O('cove','Cove & profile lighting'),
      O('bookshelf','Wall-mounted bookshelf / display shelves'),
      O('kidsbed','Bunk bed with storage')
    ]});
  }

  s.push({ id:'civil', name:'Civil & Ceiling', items:[
    A('floor','Flooring & skirting'),
    A('pop','POP / false ceiling'),
    A('wproof','Waterproofing'),
    O('pvc','PVC sheet ceiling'),
    O('flrup','Premium flooring upgrade (wooden / large-format)'),
    O('cove','Cove lighting profile across ceilings')
  ]});

  s.push({ id:'finishes', name:'Finishes', items:[
    A('putty','Putty & primer'),
    A('paint','Wall / ceiling paint'),
    A('wallpaper','Wallpaper'),
    A('panel','Panelling finish'),
    O('texture','Premium texture paint finish'),
    O('wpall','Designer wallpapers (whole home)'),
    O('fluted','Fluted / 3D panelling (feature walls)')
  ]});

  s.push({ id:'electrical', name:'Electrical & Plumbing', items:[
    { id:'lp', name:'Light points per room', inc:ALL, mult:rooms, multLabel:'rooms',
      note:'6 ceiling lights, 4 × 5 AMP switch & socket, 1 × 15 AMP socket' },
    { id:'led', name:'LED lights per room', inc:ALL, mult:rooms, multLabel:'rooms',
      note:'4 × 10W LED lights, 2 × 6W downlighters' },
    O('sock15','15 AMP socket'),
    O('sw5','5 AMP switch & socket'),
    O('ceilight','Ceiling light'),
    O('fans','Ceiling fans with regulators'),
    O('modsw','Designer modular switch plates'),
    O('acpts','Additional AC / geyser power points'),
    O('data','Data / TV / internet points'),
    O('spots','LED spot lights for all rooms'),
    O('mcb','Distribution board & MCB upgrade'),
    O('plumb','Plumbing & waterproofing upgrade')
  ]});

  s.push({ id:'handover', name:'Handover', items:[
    A('clean','Deep cleaning'),
    O('pest','Pest control treatment'),
    O('decor','Home decor & styling package')
  ]});

  /* ---- Areas with add-ons only ---- */
  s.push({ id:'bath', name:'Bathrooms (all '+beds+')', mult:beds, multLabel:'bathrooms', items:[
    O('vanity','Vanity unit'),
    O('mirror','LED mirror'),
    O('glass','Shower glass partition'),
    O('fit','Premium sanitary fittings'),
    O('storage','Wall-hung storage cabinet'),
    O('bceil','Waterproof false ceiling'),
    O('niche','Shower niche with LED'),
    O('rain','Rain shower & thermostatic mixer'),
    O('towel','Heated towel rail'),
    O('wtiles','Designer wall tiles / feature wall'),
    O('geyser','Geyser with concealed housing'),
    O('accs','Bath accessories set (premium)')
  ]});

  s.push({ id:'study', name:'Study / Home Office', items:[
    O('table','Study / work table with storage'),
    O('shelf','Wall bookshelf / open shelves'),
    O('chair','Ergonomic chair'),
    O('ceil','False ceiling with lights'),
    O('panel','Acoustic / feature wall panel'),
    O('sofa','Guest sofa-cum-bed'),
    O('curtain','Curtains & blinds'),
    O('cable','Concealed cable & power management')
  ]});

  s.push({ id:'utility', name:'Utility / Wash Area', items:[
    O('cab','Utility cabinets'),
    O('wm','Washing machine housing unit'),
    O('dry','Cloth drying system (ceiling mounted)'),
    O('iron','Ironing & laundry station'),
    O('tile','Anti-skid wall & floor tiles')
  ]});

  s.push({ id:'passage', name:'Passage / Corridor', items:[
    O('ceil','False ceiling with cove lights'),
    O('panel','Wall paneling / wainscoting'),
    O('storage','Floor-to-ceiling storage cabinets'),
    O('art','Gallery wall with art lighting'),
    O('console','Passage console & mirror'),
    O('sensor','Motion-sensor night lights')
  ]});

  if(big){
    s.push({ id:'staircase', name:'Staircase', items:[
      O('rail','Designer railing (glass / SS / wood)'),
      O('tread','Wooden / marble step cladding'),
      O('under','Under-stair storage / mini study / powder room'),
      O('light','Step LED lighting'),
      O('wall','Staircase feature wall & chandelier')
    ]});
  }

  s.push({ id:'balcony', name:'Terrace / Balcony', items:[
    O('pvc','PVC sheet ceiling (terrace garden)'),
    O('deck','Deck flooring'),
    O('seat','Seating & planters'),
    O('swing','Swing / jhula with hanging chair'),
    O('garden','Vertical garden with irrigation'),
    O('grill','Safety grill / invisible grill'),
    O('pergola','Pergola / canopy'),
    O('blinds','Outdoor roller blinds'),
    O('light','Outdoor string & wall lights'),
    O('bbq','Outdoor bar / BBQ counter')
  ]});

  s.push({ id:'extras', name:'Smart & Whole-Home Extras', items:[
    O('lights','Designer lighting package'),
    O('smart','Smart home automation'),
    O('cctv','CCTV & video door phone'),
    O('ac','AC concealment & ducting work'),
    O('curtains','Whole-home curtain & blind package'),
    O('solar','Solar water heater / inverter wiring'),
    O('sliding','Sliding doors / glass partitions'),
    O('fire','Fire & smoke safety system')
  ]});

  return s;
}


/* ===== Line-art icons (inner SVG markup, 64x64 viewBox) ===== */
export const IC = {
 door:'<rect x="18" y="6" width="28" height="52" rx="2"/><rect x="23" y="12" width="18" height="16"/><rect x="23" y="33" width="18" height="18"/><circle cx="41" cy="31" r="1.6"/>',
 lock:'<rect x="16" y="28" width="32" height="26" rx="3"/><path d="M22 28v-6a10 10 0 0 1 20 0v6"/><circle cx="32" cy="40" r="3"/><path d="M32 43v5"/>',
 panel:'<rect x="8" y="10" width="48" height="44" rx="2"/><path d="M18 10v44M28 10v44M38 10v44M48 10v44"/>',
 shoe:'<rect x="12" y="8" width="40" height="48" rx="2"/><path d="M12 24h40M12 40h40"/><path d="M17 22c3-5 7-5 9-1l4 1v1H17zM17 38c3-5 7-5 9-1l4 1v1H17zM35 22c3-5 7-5 9-1l4 1v1H35z"/>',
 tv:'<rect x="12" y="8" width="40" height="24" rx="2"/><path d="M32 32v4M24 36h16"/><rect x="8" y="40" width="48" height="14" rx="2"/><path d="M24 40v14M40 40v14M16 47h2M46 47h2M30 47h4"/>',
 ceiling:'<rect x="6" y="8" width="52" height="48" rx="2"/><rect x="14" y="16" width="36" height="32" rx="2"/><circle cx="32" cy="32" r="5"/><path d="M32 24v-3M32 43v-3M24 32h-3M43 32h-3"/>',
 curtain:'<path d="M8 10h48"/><path d="M12 10c-2 14 4 28 0 44h12c-4-16 2-30 0-44M52 10c2 14-4 28 0 44H40c4-16-2-30 0-44"/>',
 sofa:'<rect x="14" y="16" width="36" height="14" rx="5"/><rect x="8" y="26" width="48" height="16" rx="5"/><path d="M14 42v6M50 42v6"/>',
 showcase:'<rect x="14" y="6" width="36" height="52" rx="2"/><path d="M14 22h36M14 38h36M32 6v52"/><circle cx="23" cy="15" r="3"/><rect x="36" y="27" width="9" height="7"/><path d="M20 54v-8h8v8"/>',
 kitchen:'<rect x="6" y="8" width="52" height="14" rx="2"/><path d="M22 8v14M38 8v14M4 36h56"/><rect x="6" y="36" width="52" height="20" rx="2"/><path d="M32 36v20M14 44h4M46 44h4"/>',
 chimney:'<path d="M24 6h16v14l8 10H16l8-10z"/><path d="M32 30v8"/><rect x="12" y="44" width="40" height="10" rx="2"/><circle cx="24" cy="49" r="2.5"/><circle cx="40" cy="49" r="2.5"/>',
 tiles:'<rect x="8" y="8" width="48" height="48" rx="2"/><path d="M8 24h48M8 40h48M24 8v48M40 8v48"/>',
 pantry:'<rect x="16" y="4" width="32" height="56" rx="2"/><path d="M16 22h32M16 40h32M32 4v56M28 30v4M36 30v4"/>',
 drawer:'<rect x="8" y="14" width="48" height="38" rx="2"/><path d="M8 27h48M8 40h48M26 20.5h12M26 33.5h12M26 46h12"/>',
 island:'<rect x="6" y="28" width="52" height="7" rx="2"/><rect x="12" y="35" width="40" height="20"/><path d="M32 35v20M16 26v-6a4 4 0 0 1 8 0v6M40 26v-6a4 4 0 0 1 8 0v6"/>',
 dining:'<rect x="10" y="26" width="44" height="6" rx="2"/><path d="M16 32v22M48 32v22M4 30v-8h4v8M56 30v-8h-4v8"/>',
 chair:'<path d="M22 6v28h22"/><rect x="18" y="34" width="28" height="7" rx="2"/><path d="M22 41v16M44 41v16M22 14h14"/>',
 crockery:'<rect x="12" y="6" width="40" height="52" rx="2"/><path d="M32 6v52M12 38h40M20 48h4M40 48h4"/><circle cx="22" cy="24" r="6"/><circle cx="42" cy="24" r="6"/>',
 pendant:'<path d="M32 4v18"/><path d="M16 42c0-12 7-20 16-20s16 8 16 20z"/><path d="M26 48c2 4 10 4 12 0"/>',
 bed:'<rect x="8" y="14" width="48" height="16" rx="3"/><rect x="6" y="30" width="52" height="16" rx="3"/><path d="M10 46v8M54 46v8M12 30v-6h16v6M36 30v-6h16v6"/>',
 wardrobe:'<rect x="10" y="6" width="44" height="52" rx="2"/><path d="M32 6v52M28 30v6M36 30v6M10 46h44"/>',
 walkin:'<path d="M12 14h40M12 34h40"/><path d="M20 14l-5 8h10zM32 14l-5 8h10zM44 14l-5 8h10z"/><rect x="12" y="42" width="40" height="12" rx="2"/><path d="M32 42v12"/>',
 dresser:'<ellipse cx="32" cy="18" rx="12" ry="13"/><rect x="10" y="36" width="44" height="6" rx="2"/><path d="M14 42v14M50 42v14M24 42v8h16v-8"/>',
 mirror:'<rect x="18" y="6" width="28" height="52" rx="14"/><path d="M26 16l-4 6M30 14l-8 12"/>',
 sidetable:'<rect x="16" y="28" width="32" height="26" rx="2"/><path d="M16 41h32M30 34.5h4M30 47.5h4M22 28l3-12h14l3 12"/>',
 desk:'<rect x="6" y="30" width="52" height="5" rx="1"/><path d="M10 35v21M54 35v21"/><rect x="22" y="10" width="20" height="14" rx="1"/><path d="M32 24v6M28 30h8"/>',
 bookshelf:'<rect x="10" y="6" width="44" height="52" rx="2"/><path d="M10 22h44M10 38h44M16 22V12M21 22v-8M26 22V10M34 38V28M40 38v-8M45 38V28M16 54V42M22 54v-8M28 54V40"/>',
 vanity:'<rect x="10" y="32" width="44" height="24" rx="2"/><path d="M32 32v24M8 30h48M32 10v10M26 10h12"/>',
 shower:'<path d="M14 56V16a8 8 0 0 1 8-8h14"/><path d="M36 8l12 8H32z"/><path d="M34 24v4M40 24v6M46 24v4M36 36v4M43 38v4"/>',
 pooja:'<path d="M32 4l20 14H12z"/><rect x="14" y="18" width="36" height="34"/><path d="M22 52V28a10 10 0 0 1 20 0v24M10 52h44M8 58h48"/><circle cx="32" cy="38" r="3"/>',
 swing:'<path d="M14 6h36M20 6l-2 30M44 6l2 30"/><rect x="14" y="36" width="36" height="6" rx="3"/><path d="M20 42v10M44 42v10"/>',
 plant:'<path d="M22 42h20l-3 14H25z"/><path d="M32 42V24M32 32c-8 0-10-8-10-14 8 0 10 6 10 14zM32 28c8 0 10-8 10-14-8 0-10 6-10 14z"/>',
 paint:'<rect x="10" y="8" width="36" height="14" rx="3"/><path d="M46 15h6v14H30v8"/><rect x="26" y="37" width="8" height="18" rx="2"/>',
 floor:'<rect x="6" y="14" width="52" height="36" rx="2"/><path d="M6 26h52M6 38h52M22 14v12M40 26v12M28 38v12"/>',
 switch:'<rect x="16" y="8" width="32" height="48" rx="4"/><rect x="26" y="18" width="12" height="18" rx="2"/><circle cx="32" cy="46" r="2"/>',
 wire:'<path d="M6 44h14l6-22 8 34 6-14h18"/><circle cx="6" cy="44" r="2.5"/><circle cx="58" cy="42" r="2.5"/>',
 bulb:'<path d="M24 38c-6-4-8-8-8-14a16 16 0 0 1 32 0c0 6-2 10-8 14z"/><path d="M26 46h12M28 52h8M6 22h4M54 22h4M12 8l3 3M52 8l-3 3"/>',
 smart:'<path d="M8 32L32 10l24 22"/><path d="M14 28v26h36V28"/><path d="M25 42a10 10 0 0 1 14 0M21 38a15 15 0 0 1 22 0"/><circle cx="32" cy="47" r="1.5"/>',
 cctv:'<rect x="8" y="16" width="40" height="18" rx="3"/><circle cx="38" cy="25" r="5"/><path d="M48 22l8-4M20 34v10h-8"/>',
 ac:'<rect x="6" y="14" width="52" height="20" rx="4"/><path d="M12 28h40M16 40c0 4 4 4 4 8M32 40c0 4 4 4 4 8M48 40c0 4 4 4 4 8"/>',
 rug:'<rect x="8" y="16" width="48" height="32" rx="3"/><rect x="14" y="22" width="36" height="20" rx="2"/><path d="M8 24H4M8 32H4M8 40H4M56 24h4M56 32h4M56 40h4M32 22l8 10-8 10-8-10z"/>',
 bar:'<rect x="6" y="34" width="52" height="6" rx="2"/><path d="M10 40v16M54 40v16M18 34V18h6v16M30 34V12h5v22M42 34V20h6v14"/>',
 jaali:'<rect x="10" y="6" width="44" height="52" rx="2"/><path d="M10 6l44 52M54 6L10 58M10 32h44M32 6v52"/>',
 stairs:'<path d="M6 56h14V44h14V32h14V20h10M6 56h52M12 38l36-26"/>',
 speaker:'<rect x="16" y="6" width="32" height="52" rx="4"/><circle cx="32" cy="20" r="5"/><circle cx="32" cy="42" r="9"/><circle cx="32" cy="42" r="3"/>',
 bench:'<rect x="8" y="26" width="48" height="10" rx="3"/><path d="M12 36v18M52 36v18M8 44h48"/>',
 grill:'<rect x="10" y="8" width="44" height="48"/><path d="M10 20h44M10 32h44M10 44h44M22 8v48M32 8v48M42 8v48"/>',
 blinds:'<rect x="8" y="8" width="48" height="6" rx="3"/><path d="M12 20h40M12 26h40M12 32h40M12 38h40M32 38v10"/><circle cx="32" cy="51" r="3"/>',
 pergola:'<path d="M8 20h48M8 20v36M56 20v36M12 14h40M16 20v-6M26 20v-6M38 20v-6M48 20v-6"/>',
 sink:'<path d="M8 28h48M12 28c0 14 8 20 20 20s20-6 20-20"/><path d="M32 8v10a6 6 0 0 1 6 6"/>',
 bin:'<path d="M18 18h28l-3 38H21z"/><path d="M14 18h36M26 18v-6h12v6M26 26v22M38 26v22"/>',
 geyser:'<rect x="18" y="6" width="28" height="44" rx="12"/><circle cx="32" cy="22" r="5"/><path d="M26 50v6M38 50v6"/>',
 fire:'<path d="M32 6c4 10 14 14 14 28a14 14 0 0 1-28 0c0-8 4-10 6-16 2 4 4 6 8 6-2-6-2-12 0-18z"/>',
 clean:'<path d="M32 8l5 16 16 5-16 5-5 16-5-16-16-5 16-5z"/><path d="M50 8v8M46 12h8"/>',
 fan:'<circle cx="32" cy="32" r="4"/><path d="M32 28c-2-10 6-18 12-14-2 8-6 12-12 14zM36 32c10-2 18 6 14 12-8-2-12-6-14-12zM32 36c2 10-6 18-12 14 2-8 6-12 12-14zM28 32c-10 2-18-6-14-12 8 2 12 6 14 12z"/>',
 art:'<rect x="10" y="10" width="44" height="44" rx="2"/><rect x="18" y="18" width="28" height="28"/><path d="M18 40l8-8 6 6 6-8 8 10"/>',
 washer:'<rect x="12" y="8" width="40" height="48" rx="3"/><circle cx="32" cy="34" r="12"/><circle cx="32" cy="34" r="6"/><circle cx="20" cy="16" r="2"/><path d="M28 16h16"/>',
 box:'<path d="M8 22l24-12 24 12v24L32 58 8 46z"/><path d="M8 22l24 12 24-12M32 34v24"/>'
};
const ICON_RULES = [
  [/curtain|blind|sheer/,'curtain'],
  [/dining table|upgrade to 8|centre table|coffee/,'dining'],
  [/chair/,'chair'],
  [/study overhead|open shelf|bookshel|library|shelves/,'bookshelf'],
  [/study|work table|desk/,'desk'],
  [/ceiling light|light point|downlight|\bled lights\b/,'bulb'],
  [/\bpaint\b|putty|primer/,'paint'],
  [/modular|carcase|basket/,'kitchen'],
  [/\bjali\b|jaali/,'jaali'],
  [/dressing|dresser|console/,'dresser'],
  [/mirror/,'mirror'],
  [/smart lock|digital/,'lock'],
  [/smart home|automation/,'smart'],
  [/cctv|door phone/,'cctv'],
  [/pooja|mandir|\bbells?\b/,'pooja'],
  [/skirting|flooring/,'floor'],
  [/stair|railing|step cladding/,'stairs'],
  [/wiring|circuit/,'wire'],
  [/tiles|inlay/,'tiles'],
  [/flooring|\bdeck\b/,'floor'],
  [/panel|wainscot|cladding|fluted|charcoal|feature wall|dado|wallpaper|texture wall/,'panel'],
  [/\bdoor\b|doors/,'door'],
  [/jaali|partition|lattice/,'jaali'],
  [/shoe|umbrella|key holder/,'shoe'],
  [/speaker|theatre|sound/,'speaker'],
  [/\btv\b/,'tv'],
  [/ceiling/,'ceiling'],
  [/shower|rain|towel/,'shower'],
  [/planter|garden|plant/,'plant'],
  [/bench|window seat/,'bench'],
  [/sofa|seating|ottoman/,'sofa'],
  [/chimney|\bhob\b/,'chimney'],
  [/waste|\bbin\b/,'bin'],
  [/sink/,'sink'],
  [/tandem|drawer|cutlery|organiser/,'drawer'],
  [/island|breakfast/,'island'],
  [/\btall\b|pantry/,'pantry'],
  [/basin|vanity|accessories/,'vanity'],
  [/\bbar\b|bbq/,'bar'],
  [/trolley|shutter|handle|carousel|pull-out|dish|spice|bottle|overhead|kitchen|counter|appliance|\bro\b/,'kitchen'],
  [/dining table|upgrade to 8/,'dining'],
  [/crockery|sideboard|buffet/,'crockery'],
  [/chair/,'chair'],
  [/pendant|chandelier/,'pendant'],
  [/light point/,'bulb'],
  [/wiring|circuit/,'wire'],
  [/switch|socket|mcb|distribution/,'switch'],
  [/\bfans?\b/,'fan'],
  [/\bac\b|ducting/,'ac'],
  [/geyser|solar/,'geyser'],
  [/lighting|\bled\b|lights?\b|lamp|cove|spot/,'bulb'],
  [/side table|bedside/,'sidetable'],
  [/study|work table|desk/,'desk'],
  [/bookshel|library|shelves|shelf/,'bookshelf'],
  [/showcase|display|alcove|niche/,'showcase'],
  [/walk-in|closet/,'walkin'],
  [/wardrobe/,'wardrobe'],
  [/\bbed\b|bunk/,'bed'],
  [/swing|jhula/,'swing'],
  [/grill/,'grill'],
  [/pergola|canopy/,'pergola'],
  [/paint|putty|primer|\bpop\b/,'paint'],
  [/rug|decor|styling/,'rug'],
  [/\bart\b|gallery/,'art'],
  [/fire|smoke/,'fire'],
  [/clean|pest|handover/,'clean'],
  [/plumb|waterproof/,'sink'],
  [/tile/,'tiles'],
  [/washing|laundry|ironing/,'washer'],
  [/sanitary|fittings/,'sink'],
  [/cable|power management/,'wire'],
  [/cabinet|storage/,'pantry']
];
const _iconCache = {};
export function iconKey(name){
  if(_iconCache[name]) return _iconCache[name];
  const n = name.toLowerCase();
  let k = 'box';
  for(const [re,key] of ICON_RULES){ if(re.test(n)){ k = key; break; } }
  return (_iconCache[name] = k);
}

export const ROOM_ICONS = {
  entrance: "door", living: "sofa", pooja: "pooja", kitchen: "kitchen", dining: "dining",
  balcony: "plant", electrical: "wire", civil: "floor", finishes: "paint", handover: "clean",
};
